import axios from '@/utils/request';

// 获取试卷列表
export const getPapers = (data: any) => {
  return axios.request({
    url: 'Exam/GetPapers',
    method: 'GET',
    params: data,
  });
};

// 获取试题信息
export const getPaper = (data: any) => {
  return axios.request({
    url: 'Exam/GetPaper',
    method: 'GET',
    params: data,
  });
};

// 保存答案
export const saveAnswer = (data: any) => {
  const config: any = {
    url: 'Exam/SaveAnswer',
    method: 'POST',
    data,
    showLoading: false,
  };
  return axios.request(config);
};

// 提交答案
export const submitAnswer = (data: any) => {
  return axios.request({
    url: 'Exam/SubmitAnswer',
    method: 'POST',
    data,
  });
};

// 切屏提醒
export const submitPrompt = (data: any) => {
  const config: any = {
    url: 'Exam/SubmitPrompt',
    method: 'POST',
    data,
    showLoading: false,
  };
  return axios.request(config);
};

// 监考拍照
export const takePhoto = (data: any) => {
  return axios.request({
    url: 'Exam/TakePhoto',
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data,
  });
};

// 考试情况查询
export const getRecord = (data: any) => {
  return axios.request({
    url: 'Exam/GetRecord',
    method: 'GET',
    params: data,
  });
};

// 考试错题查询
export const getWrong = (data: any) => {
  return axios.request({
    url: 'Exam/GetWrong',
    method: 'GET',
    params: data,
  });
};

// 答卷情况统计
export const getStatistics = (data: any) => {
  return axios.request({
    url: 'Exam/GetStatistics',
    method: 'GET',
    params: data,
  });
};

// 考试排行榜
export const getRanking = (data: any) => {
  return axios.request({
    url: 'Exam/GetRanking',
    method: 'GET',
    params: data,
  });
};
